export default __webpack_public_path__ + "static/media/peek.ddbc116b.gif";